module.exports = require("./lib/randomstring");


//////////////////
// WEBPACK FOOTER
// ./node_modules/randomstring/index.js
// module id = 640
// module chunks = 1